var ShiftPlanningCtrl = function(_, $state, employees, moment) {
  this.employees = employees;
  this._state = $state;
  this._moment = moment;
  this.currentEmployeeId = _.get(this._state, 'params.employeeId');

  // init
  if (!this.currentEmployeeId) {
    this.currentEmployeeId = this.employees[0]._id;
    this.employeeChanged();
  }
};

ShiftPlanningCtrl.prototype.employeeChanged = function() {
  var date = _.get(
    this._state,
    'params.date',
    this._moment()
      .startOf('month')
      .format('YYYY-MM-DD'),
  );
  var openTab = _.get(this._state, 'params.openTab', 'weeklyPlanning');

  this._state.go('private.main.shiftPlanning.workingHours', {
    employeeId: this.currentEmployeeId,
    date: date,
    openTab: openTab,
  });
};

module.exports = ShiftPlanningCtrl;



// WEBPACK FOOTER //
// ./src/app/modules/shiftPlanning/ShiftPlanningCtrl.js